import React from "react";
import { useTranslation } from "react-i18next";
import { ConnectionStatusEnum } from "@SeemplicityDev/shared/integrations";
import { Tooltip } from "@SeemplicityDev/shared";
import EntityLogo from "../../Components/EntityLogo/EntityLogo";

interface LastSyncItemProps {
  onClickHandler: (id?: string) => void;
  title?: string;
  name?: string;
  src?: string;
  id?: string;
  lastUpdate?: string;
  connectionStatus?: string;
}

const LastSyncItem: React.FC<LastSyncItemProps> = ({
  onClickHandler,
  title,
  name,
  src,
  id,
  lastUpdate,
  connectionStatus,
}) => {
  const { t } = useTranslation();
  const onItemClick = () => {
    onClickHandler(id);
  };

  const displayUpdate = lastUpdate || "N/A";

  return (
    <li>
      <div
        className={`data-table-row`}
        data-testid={`last-sync-row-${id}`}
        onClick={onItemClick}
      >
        <div
          className={`data-table-cell integration-content`}
          data-testid={`integration-row-${name}`}
        >
          <div className={`datasource`}>
            <EntityLogo
              className={`last-sync-ds-icon`}
              name={name}
              logo={src}
              size="s"
              isCompact
              isSquare
            />
            <Tooltip content={title}>
              <div className={"data-source-name"}>{title}</div>
            </Tooltip>
            {connectionStatus === ConnectionStatusEnum.FAILED && (
              <>
                <Tooltip type="info" content={t(`Connection Error`)}>
                  <i className={`seem-icon seem-icon-error connection-error`} />
                </Tooltip>
              </>
            )}
          </div>
        </div>
        <div
          className={`data-table-cell update-content ${
            !lastUpdate ? "not-collected" : ""
          }`}
          data-testid={`update-row-${name}`}
        >
          {displayUpdate}
        </div>
      </div>
    </li>
  );
};

export default LastSyncItem;
